<div class="page-shell page-shell--flow">
<div class="start-container">
  <div class="get-started-section">
    <h1 class="section-title">{{ 'start.getStarted' | translate }}</h1>
    <div class="progress-text">{{ 'start.progressText' | translate: { current: currentStep, total: totalSteps } }}</div>
    
    <div class="progress-card">
      <div class="steps-container">
        <div class="step" *ngFor="let step of onboardingSteps; let i = index" 
             [class.active]="step.status === 'active'"
             [class.completed]="step.status === 'completed'"
             [class.skipped]="step.status === 'skipped'">
          
          <div class="step-indicator">
            <div class="step-circle" [class.completed]="step.status === 'completed'"
                 [class.skipped]="step.status === 'skipped'">
              <mat-icon *ngIf="step.status === 'completed'">check</mat-icon>
              <mat-icon *ngIf="step.status === 'skipped'">remove</mat-icon>
            </div>
          </div>
          
          <div class="step-content">
            <div class="step-header">
              <h3 class="step-title">{{ 'start.' + step.id + '.title' | translate }}</h3>
            </div>
            
            <div class="step-description" *ngIf="step.description && step.isExpanded">
              {{ 'start.' + step.id + '.description' | translate: { provider: getProviderName() } }}
            </div>
            
            <div class="step-menu" *ngIf="step.isExpanded">
              <div class="menu-item" *ngFor="let menuItem of step.menuItems">
                <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
                <span class="menu-text">{{ 'start.' + step.id + '.description' | translate: { provider: getProviderName() } }}</span>
              </div>
            </div>
            
            <div class="step-signature-options" *ngIf="step.id === 'installation' && step.isExpanded">
              <div class="signature-options-container">
                <h4 class="signature-options-title">{{ 'signatures.newSignatureHeader' | translate }}</h4>
                
                <div class="choice-container">
                  <div class="choice-option" (click)="goToCreateNewSignature()">
                    <mat-icon>auto_fix_high</mat-icon>
                    <div class="choice-content">
                      <h3>{{ 'signatures.wantToGenerateSignature' | translate }}</h3>
                      <p>{{ 'signatures.goToGenerator' | translate }}</p>
                    </div>
                  </div>

                  <div class="choice-option" (click)="goToChooseTemplate()">
                    <mat-icon>library_books</mat-icon>
                    <div class="choice-content">
                      <h3>{{ 'start.installation.signatureOptions.chooseTemplate.title' | translate }}</h3>
                      <p>{{ 'start.installation.signatureOptions.chooseTemplate.description' | translate }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            
            <div class="step-actions" *ngIf="step.status === 'active' && (step.action || step.skipAction)">
              <button mat-raised-button 
                      color="primary" 
                      *ngIf="step.action && step.id !== 'installation'"
                      (click)="goToStep(step.id)">
                {{ 'start.actions.' + (step.id === 'onboarding' ? 'start' : 'continue') | translate }}
              </button>
              
              <button mat-stroked-button 
                      *ngIf="step.skipAction"
                      (click)="step.skipAction.action()">
                {{ 'start.actions.skip' | translate }}
              </button>
            </div>

            <div class="step-actions" *ngIf="step.status === 'skipped' || step.status === 'completed' && step.action">
              <a href="#" 
                 class="activate-link" 
                 (click)="activateStep(step.id); $event.preventDefault()">
                {{ 'start.actions.activate' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="video-section">
    <div class="video-header">
      <h2 class="section-title">{{ 'start.videoTutorials.title' | translate }}</h2>
      <a class="youtube-link" (click)="goToYoutubeChannel(); $event.preventDefault()">
        {{ 'start.videoTutorials.youtubeLink' | translate }}
      </a>
    </div>
    
    <div class="video-grid">
      <div class="video-card" *ngFor="let video of videoTutorials">
        <div class="video-thumbnail">
          <img [src]="video.thumbnail" [alt]="video.title" class="thumbnail-image">
          <div class="play-button" (click)="openVideoModal(video)">
            <mat-icon>play_circle</mat-icon>
          </div>
          <div class="watched-badge" *ngIf="video.watched">
            <mat-icon>check_circle</mat-icon>
          </div>
        </div>
        
        <div class="video-info">
          <h4 class="video-title">{{ video.title }}</h4>
          <span class="video-duration">{{ video.duration }}</span>
        </div>
        
        <button mat-stroked-button 
                class="see-video-button"
                (click)="openVideoModal(video)">
          {{ 'start.videoTutorials.seeVideo' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="help-section">
    <h2 class="section-title">{{ 'start.help.title' | translate }}</h2>
    <p class="help-description">{{ 'start.help.description' | translate }}</p>
    
    <div class="help-links">
      <a class="help-link" (click)="openLiveChat(); $event.preventDefault()">{{ 'start.help.askQuestion' | translate }}</a>
      <a class="help-link" (click)="openTutorialVideo(); $event.preventDefault()">{{ 'start.help.watchTutorial' | translate }}</a>
      <a class="help-link" (click)="openHelpCenter(); $event.preventDefault()">{{ 'start.help.helpCenter' | translate }}</a>
    </div>
  </div>
</div>
</div>
